<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperServiceAssistants',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'HumanResourcesModule',
    };
  },
};
</script>
